<template>
    <div>
        <error-page code="403" :description="description"></error-page>
    </div>
</template>

<script>
    import ErrorPage from './Error'
    
    export default {
        data: function() {
            return {
                description: 'The content you are trying to reach is forbidden.',
            }
        },
        components: {
            ErrorPage,
        }
    }
</script>



// WEBPACK FOOTER //
// 403.vue?24c07c2a